export const VARIANTS = ['primary', 'orga', 'certif', 'admin'];